function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M56 140h56a12 12 0 0012-12V32a12 12 0 00-3.52-8.48l-16-16A12 12 0 0096 4H56"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M83.85 60H98a6 6 0 016 6v48a6 6 0 01-6 6H84.29"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M84 32a12 12 0 00-3.52-8.48l-16-16A12 12 0 0056 4H16A12 12 0 004 16v112a12 12 0 0012 12h56a12 12 0 0012-12z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M64 114a6 6 0 01-6 6H30a6 6 0 01-6-6V66a6 6 0 016-6h28a6 6 0 016 6z"
});

var SvgSim = function SvgSim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 128 144",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgSim;